import PageEditSessionRecord from "models/view-models/page-edit-session-record";
import QueryHookFactory from "utilities/hooks/queries/query-hook-factory";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface PageEditSessionResourcePathParams {
    id: number;
}

interface PageEditSessionPutRequestParams {
    blockId: number | undefined;
}
export interface PageEditSessionActiveGetParams {
    pageId: number;
}
export interface PageEditSessionCreateParams {
    pageId: number;
    blockId?: number;
}
const baseEndpoint = "page-edit-sessions";
const resourceEndpoint = `${baseEndpoint}/:id`;
const createEndpoint = `${baseEndpoint}/start-editing`;
const activeSessionEndpoint = `${baseEndpoint}/active`;
const resourceType = PageEditSessionRecord;
const key = "page-edit-session";

export const PageEditSessionService = {
    useCreate: ServiceHookFactory.useNestedCreate<
        PageEditSessionRecord,
        PageEditSessionCreateParams
    >(resourceType, createEndpoint),
    useUpdate: ServiceHookFactory.useUpdateFromPutParams<
        PageEditSessionRecord,
        PageEditSessionPutRequestParams,
        PageEditSessionResourcePathParams
    >(PageEditSessionRecord, resourceEndpoint),
    useDelete: ServiceHookFactory.useDelete(resourceEndpoint),
    useGet: ServiceHookFactory.useGet<
        PageEditSessionRecord,
        PageEditSessionResourcePathParams
    >(PageEditSessionRecord, resourceEndpoint),
    useGetActiveSessionQuery: QueryHookFactory.useGetQuery<
        PageEditSessionRecord,
        undefined,
        PageEditSessionActiveGetParams
    >(key, PageEditSessionRecord, activeSessionEndpoint),
    useListActiveSessions: QueryHookFactory.useListQuery<
        PageEditSessionRecord,
        PageEditSessionActiveGetParams
    >(key, PageEditSessionRecord, activeSessionEndpoint),
};
